import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../../reducers/organization-admin/organization-admin.reducer';

export const selectOrganizationAdminState = createFeatureSelector<State>('organizationAdmin');

export const selectOrganizations = createSelector(
  selectOrganizationAdminState,
  (state) => state.organizations
);

export const selectOrganizationTypes = createSelector(
  selectOrganizationAdminState,
  (state) => state.organizationTypes
);

export const selectStates = createSelector(
  selectOrganizationAdminState,
  (state) => state.states
);

export const selectIsLoading = createSelector(
  selectOrganizationAdminState,
  (state) => state.isLoading
);

export const selectError = createSelector(
  selectOrganizationAdminState,
  (state) => state.error
);
